export const REPORT_TYPES = {
  RAW_MATERIAL_INSPECTION: 'RAW_MATERIAL_INSPECTION',
  FOOD_HANDLER_HYGIENE: 'FOOD_HANDLER_HYGIENE',
  SUPPLIER_RECORD: 'SUPPLIER_RECORD',
};

export const REPORT_TYPE_LABELS = {
  [REPORT_TYPES.RAW_MATERIAL_INSPECTION]: 'Raw Material Inspection Record',
  [REPORT_TYPES.FOOD_HANDLER_HYGIENE]: "Food Handler's Personal Hygiene Record",
  [REPORT_TYPES.SUPPLIER_RECORD]: 'Supplier Record',
};

export const REPORT_TYPE_OPTIONS = [
  { value: REPORT_TYPES.RAW_MATERIAL_INSPECTION, label: REPORT_TYPE_LABELS[REPORT_TYPES.RAW_MATERIAL_INSPECTION] },
  { value: REPORT_TYPES.FOOD_HANDLER_HYGIENE, label: REPORT_TYPE_LABELS[REPORT_TYPES.FOOD_HANDLER_HYGIENE] },
  { value: REPORT_TYPES.SUPPLIER_RECORD, label: REPORT_TYPE_LABELS[REPORT_TYPES.SUPPLIER_RECORD] },
];

// field types
const TEXT = 'text';
const NUMBER = 'number';
const DATE = 'date';
const SELECT = 'select';

const YN_OPTIONS = ['Y', 'N'];
const YN_NR_OPTIONS = ['Y', 'N', 'NR'];
const ACCEPTED_REJECTED_OPTIONS = ['Accepted', 'Rejected'];
const C_NC_PC_OPTIONS = ['C', 'NC', 'PC'];

export const REPORT_FIELDS = {
  [REPORT_TYPES.RAW_MATERIAL_INSPECTION]: [
    { key: 'receivingDate', label: 'Receiving Date', type: DATE },
    { key: 'rmName', label: 'RM Name', type: TEXT },
    { key: 'supplierName', label: 'Supplier Name', type: TEXT },
    { key: 'supplierFssaiLicNo', label: 'Supplier FSSAI Lic. No.', type: TEXT },
    { key: 'batchLotNo', label: 'Batch / Lot No.', type: TEXT },
    { key: 'expiryDate', label: 'Expiry Date', type: DATE },
    { key: 'qty', label: 'Qty', type: TEXT },
    { key: 'receivingTemp', label: 'Receiving Temp (°C)', type: NUMBER },
    { key: 'packagingCondition', label: 'Packaging Condition Acceptable', type: SELECT, options: YN_OPTIONS },
    { key: 'labelCoaChecked', label: 'Label / COA Checked', type: SELECT, options: YN_OPTIONS },
    { key: 'visualQuality', label: 'Visual Quality Acceptable', type: SELECT, options: YN_OPTIONS },
    { key: 'acceptedRejected', label: 'Accepted / Rejected', type: SELECT, options: ACCEPTED_REJECTED_OPTIONS },
    { key: 'correctiveAction', label: 'Corrective Action', type: SELECT, options: YN_NR_OPTIONS },
    { key: 'inspectedBy', label: 'Inspected By', type: TEXT },
    { key: 'verifiedBy', label: 'Verified By', type: TEXT },
  ],

  [REPORT_TYPES.FOOD_HANDLER_HYGIENE]: [
    { key: 'date', label: 'Date', type: DATE },
    { key: 'employeeName', label: 'Employee Name', type: TEXT },
    { key: 'department', label: 'Department', type: TEXT },
    { key: 'cleanUniform', label: 'Clean Uniform', type: SELECT, options: YN_OPTIONS },
    { key: 'personalGrooming', label: 'Personal Grooming', type: SELECT, options: YN_OPTIONS },
    { key: 'hairnetCap', label: 'Hairnet / Cap', type: SELECT, options: YN_OPTIONS },
    { key: 'glovesUsed', label: 'Gloves Used', type: SELECT, options: YN_OPTIONS },
    { key: 'nailsTrimmed', label: 'Nails Trimmed', type: SELECT, options: YN_OPTIONS },
    { key: 'noOrnaments', label: 'No Ornaments', type: SELECT, options: YN_OPTIONS },
    { key: 'noPhysicalHazards', label: 'No Physical Hazards', type: SELECT, options: YN_OPTIONS },
    { key: 'noOpenCuts', label: 'No Open Cuts', type: SELECT, options: YN_OPTIONS },
    { key: 'handWashing', label: 'Hand Washing', type: SELECT, options: YN_OPTIONS },
    { key: 'signsOfIllness', label: 'Signs of Illness', type: SELECT, options: YN_OPTIONS },
    { key: 'medicalFitness', label: 'Medical Fitness', type: SELECT, options: YN_OPTIONS },
    { key: 'supervisorRemarks', label: 'Supervisor Remarks', type: TEXT },
    { key: 'supervisedBy', label: 'Supervised By', type: TEXT },
    { key: 'verifiedBy', label: 'Verified By', type: TEXT },
  ],

  [REPORT_TYPES.SUPPLIER_RECORD]: [
    { key: 'date', label: 'Date', type: DATE },
    { key: 'supplierName', label: 'Supplier Name', type: TEXT },
    { key: 'address', label: 'Address', type: TEXT },
    { key: 'productsSupplied', label: 'Products Supplied', type: TEXT },
    { key: 'fssaiLicenseValidity', label: 'FSSAI License Validity', type: SELECT, options: YN_OPTIONS },
    { key: 'billInvoiceWithFssai', label: 'Bill / Invoice with FSSAI', type: SELECT, options: YN_OPTIONS },
    { key: 'packagingCondition', label: 'Packaging Condition', type: SELECT, options: C_NC_PC_OPTIONS },
    { key: 'tempDuringDelivery', label: 'Temp During Delivery', type: SELECT, options: C_NC_PC_OPTIONS },
    { key: 'vehicleHygiene', label: 'Vehicle Hygiene', type: SELECT, options: C_NC_PC_OPTIONS },
    { key: 'rmQualityStatus', label: 'RM Quality Status', type: SELECT, options: YN_OPTIONS },
    { key: 'complaintRejection', label: 'Complaint / Rejection', type: SELECT, options: YN_OPTIONS },
    { key: 'fssaiCompliantScore', label: 'FSSAI Compliant Score', type: NUMBER },
    { key: 'rejectionNote', label: 'Rejection Note', type: SELECT, options: YN_NR_OPTIONS },
    { key: 'monitoredBy', label: 'Monitored By', type: TEXT },
    { key: 'verifiedBy', label: 'Verified By', type: TEXT },
  ],
};

export const createEmptyRow = (reportType) => {
  const fields = REPORT_FIELDS[reportType] || [];
  return fields.reduce((acc, field) => {
    acc[field.key] = '';
    return acc;
  }, { id: crypto.randomUUID() });
};
